<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import AppShell from '@/components/AppShell.vue'
import AppTDesignProvider from '@/components/ui/AppTDesignProvider.vue'

const route = useRoute()
const isPublic = computed(() => route.meta.public === true)
</script>

<template>
  <AppTDesignProvider>
    <a class="skip-link" href="#main-content">{{ $t('common.skip') }}</a>
    <RouterView v-if="isPublic" />
    <AppShell v-else />
  </AppTDesignProvider>
</template>
